import { TriangleDownIcon, XCircleFillIcon } from "@primer/octicons-react";
import { Box, Button, IconButton, SelectPanel } from "@primer/react";
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCommonContext } from '../../contexts/common';
import { actions } from '../../state/actions/actionsWrapper';
import { RootState } from '../../state/reducers';
import { ePageBaseStatus } from "../../models/ePageBaseStatus";

type ComboboxLegalGroupProps = {
	isReadonly?: boolean;
	value?: number;
	onValueChanged: (id: number) => void;
	className?: string;
	isShowClearButton?: boolean;
	preText?: string;
	width?: string | number;
	stylingMode?: 'outlined' | 'filled' | 'underlined';
};

const ComboboxLegalGroup = (props: ComboboxLegalGroupProps) => {
	const { translate } = useCommonContext();
	const { language } = useSelector((x: RootState) => x.common);
	const { groups, status } = useSelector((state: RootState) => state.legalDocument.group);
	const dispatch = useDispatch();
	useEffect(() => {
		if (status === ePageBaseStatus.is_not_initialization) {
			dispatch(actions.legalDocument.group.LOAD_START(undefined))
		}
	}, [status]);
	const [open, setOpen] = useState(false)
	const [filter, setFilter] = useState('')
	const dataSource = useMemo(() => {
		return groups.map(item => {
			return {
				id: item.id,
				text: language === "en" ? item.name_en : item.name
			}
		})
	}, [groups, language])
	const filteredItems = useMemo(() => {
		return dataSource.filter(item => item.text.toLowerCase().includes(filter.toLowerCase()))
	}, [dataSource, filter])
	const selected = useMemo(() => {
		return dataSource.find(x => x.id === props.value)
	}, [dataSource, props.value])
	const setSelected = (selecteds: any) => {
		if (selecteds)
			props.onValueChanged(selecteds.id)
	}
	return (
		<SelectPanel
			renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
				<Box sx={{
					display: "flex"
				}}>
					<Button sx={{ flex: 1 }} trailingAction={TriangleDownIcon} aria-labelledby={` ${ariaLabelledBy}`} {...anchorProps}>
						{children || translate("Select")}
					</Button>
					{props.isShowClearButton && props.value != undefined && props.value > 0 &&
						<IconButton aria-label={"Clear"} icon={XCircleFillIcon}
							variant="invisible"
							onClick={() => {
								props.onValueChanged(0)
							}}
						></IconButton>
					}
				</Box>


			)}
			title={""}
			placeholderText="Search"
			open={open}
			onOpenChange={setOpen}
			items={filteredItems}

			// groupMetadata={""}
			selected={selected}
			onSelectedChange={setSelected}
			onFilterChange={setFilter}
			showItemDividers={true}
			overlayProps={{ width: 'large', height: 'auto' }}
		/>
	);
};

export default ComboboxLegalGroup;
